import { jsx as m, jsxs as _ } from "react/jsx-runtime";
import u from "clsx";
import { useContext as F, useRef as L } from "react";
import { C as S, F as R, a8 as j, S as A, b_ as M, G as T, aa as P } from "./helpers-458d7e27.js";
import { T as q, i as z } from "./TextHeaderInner-7887aa3a.js";
import { g as J, t as K, a as Q, c as U, C as X, b as Y, d as Z } from "./CardContentSectionItem-9f25a705.js";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const ee = {
  1: {
    maxCards: 1
  },
  2: {
    maxCards: 4
  },
  3: {
    maxCards: 9
  },
  4: {
    maxCards: 12
  }
}, v = "CardWrappedContent", y = new S(v), b = ({
  items: n,
  renderItem: s,
  maxColumns: o
}) => {
  const e = u(
    y.getComponentClassName(),
    `${y.getElementClassName("max-columns-layout")}-${o}`
  ), { maxCards: t } = ee[o], r = n.length > 0 && typeof s == "function";
  return /* @__PURE__ */ m("div", { className: e, children: r && n.slice(0, t).map((i, p) => /* @__PURE__ */ m("div", { children: s({ itemProps: i }) }, `card-${p + 1}`)) });
};
b.displayName = v;
const B = "CardContentSection", d = new S(B), te = (n, s, o, e) => {
  let t = n;
  const r = e === "display headline", i = s === "ppe";
  return z(n) || (t = {
    textGroup: n,
    ...Y
  }), r && (t = {
    ...t,
    gridItemOptions: K
  }), i && r && o === "wrapped" && (t = {
    ...t,
    gridItemOptions: Q
  }), /* @__PURE__ */ m(
    q,
    {
      className: d.getElementClassName("header"),
      ...t
    }
  );
}, ne = ({
  carouselBreakpointValues: n,
  carouselDetails: s,
  collection: o,
  collectionLength: e,
  hideOverflow: t,
  renderItem: r
}) => {
  const i = u(
    d.getElementClassName("carousel"),
    d.getElementClassName(
      `carousel-slides-per-view-${e}`
    )
  );
  return /* @__PURE__ */ m(T, { ...U, children: /* @__PURE__ */ m(P, { ...{
    items: o,
    renderItem: r,
    carouselDetails: s,
    breakpoints: n,
    classes: {
      container: i
    },
    hideOverflow: t
  } }) });
}, se = ({ renderItem: n, items: s, maxColumns: o }, e, t) => {
  const r = Z(e, t);
  return /* @__PURE__ */ m(T, { ...r, children: /* @__PURE__ */ m(
    b,
    {
      items: s,
      renderItem: n,
      maxColumns: o
    }
  ) });
}, G = ({
  cardTheme: n,
  isImageFlushed: s,
  collectionLength: o,
  maxColumns: e,
  cardVariant: t
}) => function({ itemProps: i, carouselState: p }) {
  return /* @__PURE__ */ m(
    X,
    {
      ...i,
      backgroundColor: n,
      isImageFlushed: s,
      cardVariant: t,
      collectionLength: e ?? o,
      maxColumns: e,
      isVisibleSlide: p == null ? void 0 : p.isVisibleSlide
    }
  );
}, oe = ({
  theme: n = "neutral 100",
  cardTheme: s = "white",
  headline: o,
  collection: e = [],
  disclosureType: t,
  topSpacer: r = "6vw",
  bottomSpacer: i = "6vw",
  className: p = "",
  isImageFlushed: g = !1,
  cardVariant: l,
  componentId: O,
  analyticsCompName: V,
  overlapEffect: D = "none",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  componentContext: re = {},
  displayType: W = "default",
  ...a
}) => {
  const { foundationTheme: f } = F(R), x = L(null), $ = u(d.getComponentClassName(), p), k = {
    topSpacing: r,
    bottomSpacing: i,
    rowsGap: "none"
  }, { renderAs: C } = a;
  let I = {}, N = J(e.length), c = e.length;
  const E = e.map(
    (H) => {
      var h, w;
      return ((w = (h = H.textGroup) == null ? void 0 : h.collection) == null ? void 0 : w[0]) ?? {};
    }
  );
  return C === "carousel" && (I = {
    graphicVersionTop: a.graphicVersionTop,
    graphicColorTop: a.graphicColorTop,
    graphicVersionBottom: a.graphicVersionBottom,
    graphicColorBottom: a.graphicColorBottom
  }, N = a.carouselBreakpoints, c = a.maxSlidesPerView), j(D, x), /* @__PURE__ */ _(
    A,
    {
      ref: x,
      disclosure: t,
      theme: n,
      options: k,
      id: O,
      ...I,
      className: $,
      children: [
        o && te(
          { ...o, analyticsCompName: V },
          f,
          C,
          l
        ),
        /* @__PURE__ */ m(M, { siblingDataItems: E, children: C === "wrapped" ? se(
          {
            maxColumns: a.maxColumns,
            items: e,
            renderItem: G({
              cardTheme: s,
              isImageFlushed: g,
              cardVariant: l,
              collectionLength: c,
              maxColumns: a.maxColumns
            })
          },
          f,
          l
        ) : ne({
          carouselBreakpointValues: N,
          collection: e,
          collectionLength: c,
          carouselDetails: a.carouselDetails,
          hideOverflow: W === "hideOverflow",
          renderItem: G({
            cardTheme: s,
            isImageFlushed: g,
            cardVariant: l,
            collectionLength: c
          })
        }) })
      ]
    }
  );
};
oe.displayName = B;
export {
  oe as default
};
//# sourceMappingURL=CardContentSectionType.js.map
